


































import { Component, Vue } from 'vue-property-decorator'

import LivestreamCard from '@/comps/LivestreamCard.vue'

import 'semantic-ui-css/components/container.min.css'
import 'semantic-ui-css/components/segment.min.css'
import 'semantic-ui-css/components/placeholder.min.css'
import 'semantic-ui-css/components/icon.min.css'
import 'semantic-ui-css/components/comment.min.css'
import 'semantic-ui-css/components/image.min.css'
import 'semantic-ui-css/components/grid.min.css'

import LuciaCoreAPI, { ActiveStreamsResponse, StreamStatsResponse } from '@/data/api'
import images from '@/data/images'

interface StreamStats extends StreamStatsResponse {
  elapsed: string
}

interface StreamInformation {
  ok: boolean
  name: string
  avatar: string
  stats: StreamStats | object
}

@Component({ components: { LivestreamCard } })
export default class LCLiveHub extends Vue {
  loading = true
  empty = false
  streams: StreamInformation[] = []
  images = images

  mounted () {
    const self = this
    const api = new LuciaCoreAPI()

    self.loading = true

    api.getActiveStreams()
      .then((activeStreams) => {
        activeStreams.streams.forEach(name => {
          const stream = {
            ok: false,
            name,
            avatar: images.avatars[name] ? images.avatars[name] : images.core.lcUnknownUser,
            stats: {}
          }

          api.getStream(name)
            .then((stats) => {
              stream.ok = true
              stream.stats = { ...stats }
            })

          self.streams.push(stream)
        })

        self.loading = false
        self.empty = self.streams.length === 0
      })
      .catch(() => { self.loading = false })
  }
}
